import type { DropdownTexts } from '../shared/components/dropdown/dropdown-texts';

/** The portal is English throughout, so its dropdowns skip the market translation. */
export const PORTAL_DROPDOWN_TEXTS: DropdownTexts = {
  placeholder: 'Select...',
  allSelected: 'All selected',
  countSelected: (count) => `${count} selected`,
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  searchPlaceholder: 'Search...',
};
